import * as LessonsV3 from '../model/v3/lessons';

export class LessonTypeUtilsV3 {
  public static getStudentLessonStatus(
    status: LessonsV3.LessonStatus | string | null | undefined
  ) {
    switch (status) {
      case LessonsV3.LessonStatus.Booked:
        return 'COL.LESSONS.LIST.LESSON_STATUS.BOOKED';
      case LessonsV3.LessonStatus.Complete:
        return 'COL.LESSONS.LIST.LESSON_STATUS.COMPLETE';
      case LessonsV3.LessonStatus.Due:
        return 'COL.LESSONS.LIST.LESSON_STATUS.DUE';
      case LessonsV3.LessonStatus.InProgress:
        return 'COL.LESSONS.LIST.LESSON_STATUS.IN_PROGRESS';
      case LessonsV3.LessonStatus.InvalidatedByTeacher:
      case LessonsV3.LessonStatus.Cancel:
      case LessonsV3.LessonStatus.InvalidatedByStudent:
        return 'COL.LESSONS.LIST.LESSON_STATUS.CANCELLED';
      default:
        return '';
    }
  }

  public static getStudentLessonColorClass(
    status: LessonsV3.LessonStatus | string | null | undefined
  ) {
    switch (status) {
      case LessonsV3.LessonStatus.Booked:
        return 'booked';
      case LessonsV3.LessonStatus.Complete:
        return 'complete';
      case LessonsV3.LessonStatus.Due:
        return 'due';
      case LessonsV3.LessonStatus.InProgress:
        return 'in-progress';
      case LessonsV3.LessonStatus.InvalidatedByTeacher:
      case LessonsV3.LessonStatus.Cancel:
      case LessonsV3.LessonStatus.InvalidatedByStudent:
        return 'student-invalidate';
      default:
        return '';
    }
  }
}
